import { ROUTES } from "../enums/routes";

export class CoreConstants {
  static readonly APP_SECRET_KEY = "";
}

export const SIDEBAR_MENU = [
  {
    "key": "dashboard",
    //"icon": <img src="/images/chart-histogram.svg" alt="" />,
    "label": "Dashboard",
    "link": ROUTES.ADMIN + ROUTES.DASHBOARD,
    "linkLabel": "Dashboard",
    "subMenu": undefined
  },
  {
    "key": "tenant",
    // "icon": <img src="/images/chart-histogram.svg" alt="" />,
    "label": "Tenant",
    "link": ROUTES.ADMIN + ROUTES.TENANT,
    "linkLabel": "Tenant",
    "subMenu": undefined
  },
  {
    "key": "user",
    // "icon": <img src="/images/users.svg" alt="" />,
    "label": "User",
    "link": ROUTES.ADMIN + ROUTES.USER,
    "linkLabel": "User",
    "subMenu": undefined
  },
  {
    "key": "reports",
    // "icon": <img src="/images/users.svg" alt="" />,
    "label": "Reports",
    "link": ROUTES.ADMIN + ROUTES.REPORTS,
    "linkLabel": "Reports",
    "subMenu": undefined
  },
  {
    "key": "admin-list",
    // "icon": <img src="/images/users.svg" alt="" />,
    "label": "Admin",
    "link": ROUTES.ADMIN + ROUTES.LIST,
    "linkLabel": "Admin",
    "subMenu": undefined
  },
  {
    "key": "documentation",
    "label": "Documentation",
    "link": undefined,
    "linkLabel": "Documentation",
    "subMenu": [
      {
        "key": "getting-started",
        "label": "Getting Started",
        "link": undefined,
        "linkLabel": "Getting Started",
        "subMenu": [
          { "key": "doc-overview", "label": "Overview", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_OVERVIEW, "linkLabel": "Overview" },
          { "key": "doc-quickstart", "label": "Quickstart", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_QUICKSTART, "linkLabel": "Quickstart" },
          { "key": "doc-checklist", "label": "Checklist", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_CHECKLIST, "linkLabel": "Checklist" }
        ]
      },
      {
        "key": "concepts",
        "label": "Concepts",
        "link": undefined,
        "linkLabel": "Concepts",
        "subMenu": [
          { "key": "doc-token-lifecycle", "label": "Token Lifecycle", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_TOKEN_LIFECYCLE, "linkLabel": "Token Lifecycle" },
          { "key": "doc-wallets", "label": "Wallets & IDs", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_WALLETS, "linkLabel": "Wallets & IDs" },
          { "key": "doc-geofencing", "label": "Geofencing", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_GEOFENCING, "linkLabel": "Geofencing" }
        ]
      },
      {
        "key": "portal-setup",
        "label": "Portal Setup",
        "link": undefined,
        "linkLabel": "Portal Setup",
        "subMenu": [
          { "key": "doc-tenant-registration", "label": "Tenant Registration", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_TENANT_REGISTRATION, "linkLabel": "Tenant Registration" },
          { "key": "doc-app-game-setup", "label": "App & Game Setup", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_APP_GAME_SETUP, "linkLabel": "App & Game Setup" },
          { "key": "doc-user-management", "label": "User Management", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_USER_MANAGEMENT, "linkLabel": "User Management" }
        ]
      },
      {
        "key": "api-reference",
        "label": "API Reference",
        "link": undefined,
        "linkLabel": "API Reference",
        "subMenu": [
          { "key": "create user", "label": "Create User", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_CREATE_USER, "linkLabel": "Create User" },
          { "key": "doc-fetch-wallet", "label": "Fetch Wallet", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_FETCH_WALLET, "linkLabel": "Fetch Wallet" },
          // { "key": "add tokens", "label": "Add Tokens", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_ADD_TOKENS, "linkLabel": "Add Tokens" },
          { "key": "reserve", "label": "Reserve Tokens", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_RESERVE, "linkLabel": "Reserve Tokens" },
          { "key": "revert", "label": "Revert Tokens", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_REVERT, "linkLabel": "Revert Tokens" },
          { "key": "settle tokens", "label": "Settle Tokens", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_SETTLE_TOKENS, "linkLabel": "Settle Tokens" },
          { "key": "wallet-transactions", "label": "Wallet Transactions", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_WALLET_TRANSACTIONS, "linkLabel": "Wallet Transactions" },
          { "key": "redeem", "label": "Puchase & Redeem Tokens", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_PURCHASE_AND_REDEEM_TOKENS, "linkLabel": "Puchase & Redeem" },
        ]
      },
      {
        "key": "integration-guides",
        "label": "Integration Guides",
        "link": undefined,
        "linkLabel": "Integration Guides",
        "subMenu": [
          { "key": "doc-pwa-guide", "label": "PWA Guide", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_PWA_GUIDE, "linkLabel": "PWA Guide" },
          { "key": "doc-ios-guide", "label": "iOS Guide", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_IOS_GUIDE, "linkLabel": "iOS Guide" },
          { "key": "doc-android-guide", "label": "Android Guide", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_ANDROID_GUIDE, "linkLabel": "Android Guide" }
        ]
      },
      {
        "key": "reference",
        "label": "Reference",
        "link": undefined,
        "linkLabel": "Reference",
        "subMenu": [
          { "key": "doc-error-codes", "label": "Error Codes", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_ERROR_CODES, "linkLabel": "Error Codes" },
          { "key": "doc-faq", "label": "FAQ", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_FAQ, "linkLabel": "FAQ" }
        ]
      }
    ]
  }
]

export const ADMIN_SIDEBAR_MENU = [
  {
    "key": "dashboard",
    //"icon": <img src="/images/chart-histogram.svg" alt="" />,
    "label": "Dashboard",
    "link": ROUTES.ADMIN + ROUTES.DASHBOARD,
    "linkLabel": "Dashboard",
    "subMenu": undefined
  },
  {
    "key": "application",
    // "icon": <img src="/images/chart-histogram.svg" alt="" />,
    "label": "Applications",
    "link": ROUTES.ADMIN + ROUTES.APPLICATIONS,
    "linkLabel": "Applications",
    "subMenu": undefined
  },
  {
    "key": "tenant-user",
    // "icon": <img src="/images/users.svg" alt="" />,
    "label": "User",
    "link": ROUTES.ADMIN + ROUTES.TENANT_USERS,
    "linkLabel": "User",
    "subMenu": undefined
  },
  {
    "key": "admin-list",
    // "icon": <img src="/images/users.svg" alt="" />,
    "label": "Admin",
    "link": ROUTES.ADMIN + ROUTES.LIST,
    "linkLabel": "Admin",
    "subMenu": undefined
  },
  {
    "key": "reports",
    // "icon": <img src="/images/users.svg" alt="" />,
    "label": "Reports",
    "link": ROUTES.ADMIN + ROUTES.REPORTS,
    "linkLabel": "Reports",
    "subMenu": undefined
  },
  {
    "key": "credential",
    "label": "Credential",
    "link": ROUTES.ADMIN + ROUTES.CREDENTIAL,
    "linkLabel": "Keys",
    "subMenu": undefined
  },
  {
    "key": "configuration",
    "label": "Configuration",
    "link": ROUTES.ADMIN + ROUTES.CONFIGURATION,
    "linkLabel": "Configuration",
    "subMenu": undefined
  },
  {
    "key": "documentation",
    "label": "Documentation",
    "link": undefined,
    "linkLabel": "Documentation",
    "subMenu": [
      {
        "key": "getting-started",
        "label": "Getting Started",
        "link": undefined,
        "linkLabel": "Getting Started",
        "subMenu": [
          { "key": "doc-overview", "label": "Overview", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_OVERVIEW, "linkLabel": "Overview" },
          { "key": "doc-quickstart", "label": "Quickstart", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_QUICKSTART, "linkLabel": "Quickstart" },
          { "key": "doc-checklist", "label": "Checklist", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_CHECKLIST, "linkLabel": "Checklist" }
        ]
      },
      {
        "key": "concepts",
        "label": "Concepts",
        "link": undefined,
        "linkLabel": "Concepts",
        "subMenu": [
          { "key": "doc-token-lifecycle", "label": "Token Lifecycle", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_TOKEN_LIFECYCLE, "linkLabel": "Token Lifecycle" },
          { "key": "doc-wallets", "label": "Wallets & IDs", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_WALLETS, "linkLabel": "Wallets & IDs" },
          { "key": "doc-geofencing", "label": "Geofencing", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_GEOFENCING, "linkLabel": "Geofencing" }
        ]
      },
      {
        "key": "portal-setup",
        "label": "Portal Setup",
        "link": undefined,
        "linkLabel": "Portal Setup",
        "subMenu": [
          { "key": "doc-tenant-registration", "label": "Tenant Registration", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_TENANT_REGISTRATION, "linkLabel": "Tenant Registration" },
          { "key": "doc-app-game-setup", "label": "App & Game Setup", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_APP_GAME_SETUP, "linkLabel": "App & Game Setup" },
          { "key": "doc-user-management", "label": "User Management", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_USER_MANAGEMENT, "linkLabel": "User Management" }
        ]
      },
      {
        "key": "api-reference",
        "label": "API Reference",
        "link": undefined,
        "linkLabel": "API Reference",
        "subMenu": [
          { "key": "create user", "label": "Create User", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_CREATE_USER, "linkLabel": "Create User" },
          { "key": "doc-fetch-wallet", "label": "Fetch Wallet", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_FETCH_WALLET, "linkLabel": "Fetch Wallet" },
          // { "key": "add tokens", "label": "Add Tokens", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_ADD_TOKENS, "linkLabel": "Add Tokens" },
          { "key": "reserve", "label": "Reserve Tokens", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_RESERVE, "linkLabel": "Reserve Tokens" },
          { "key": "revert", "label": "Revert Tokens", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_REVERT, "linkLabel": "Revert Tokens" },
          { "key": "settle tokens", "label": "Settle Tokens", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_SETTLE_TOKENS, "linkLabel": "Settle Tokens" },
          { "key": "wallet-transactions", "label": "Wallet Transactions", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_WALLET_TRANSACTIONS, "linkLabel": "Wallet Transactions" },
          { "key": "redeem", "label": "Puchase & Redeem", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_PURCHASE_AND_REDEEM_TOKENS, "linkLabel": "Puchase & Redeem Tokens" },
        ]
      },
      {
        "key": "integration-guides",
        "label": "Integration Guides",
        "link": undefined,
        "linkLabel": "Integration Guides",
        "subMenu": [
          { "key": "doc-pwa-guide", "label": "PWA Guide", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_PWA_GUIDE, "linkLabel": "PWA Guide" },
          { "key": "doc-ios-guide", "label": "iOS Guide", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_IOS_GUIDE, "linkLabel": "iOS Guide" },
          { "key": "doc-android-guide", "label": "Android Guide", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_ANDROID_GUIDE, "linkLabel": "Android Guide" }
        ]
      },
      {
        "key": "reference",
        "label": "Reference",
        "link": undefined,
        "linkLabel": "Reference",
        "subMenu": [
          { "key": "doc-error-codes", "label": "Error Codes", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_ERROR_CODES, "linkLabel": "Error Codes" },
          { "key": "doc-faq", "label": "FAQ", "link": ROUTES.ADMIN + ROUTES.DOCUMENTATION_FAQ, "linkLabel": "FAQ" }
        ]
      }
    ]
  },
]

export const SIDEBAR_ITEMS = {
  DASHBOARD: "dashboard",
  USER: "user",
  TENANT: "tenant",
  REPORTS: "reports",
  ADMIN: "admin-list"
}

export const ADMIN_SIDEBAR_ITEMS = {
  APPLICATIONS: "application",
  TENANT_USER: "tenant-user",
  ADMIN: "admin-list",
  CREDENTIAL: "credential",
  CONFIGURATION: "configuration"
}

export const ACTION_CONFIRMATION_MODAL_MESSAGES = {
  ON_CANCEL_OR_ROUTE_CHANGE: "The data entered is not saved. Once you exit the data will be lost. Do you want to proceed?",
  ON_MODIFY: "Once the data is edited, the previous data will be lost. Are you sure you want to proceed?"
}

export const REPORT_DURATION_VALUE = {
  LIFETIME: "lifetime",
  CURRENT: "current",
  QUARTERLY: "quarterly",
  HALF_YEAR: "half-year",
  YEAR: "year",
  CUSTOM: "custom"
}

export const USER_REPORT_DURATION_VALUE = {
  LIFETIME: "lifetime",
  CURRENT: "current",
  QUARTERLY: "quarterly",
  HALF_YEAR: "half-year",
  YEAR: "year"
}

export const REPORT_VALUE_OPTIONS = [
  {
    key: "lifetime",
    label: "All"
  },
  {
    key: "current",
    label: "Current"
  },
  {
    key: "quarterly",
    label: "Quarter"
  },
  {
    key: "half-year",
    label: "Half Year"
  },
  {
    key: "year",
    label: "Year"
  },
  {
    key: "custom",
    label: "Custom"
  }
]

export const USER_REPORT_VALUE_OPTIONS = [
  {
    key: "lifetime",
    label: "All"
  },
  {
    key: "current",
    label: "Current"
  },
  {
    key: "quarterly",
    label: "Quarter"
  },
  {
    key: "half-year",
    label: "Half Year"
  },
  {
    key: "year",
    label: "Year"
  }
]

export const DATE_TIME_FORMATE = 'MMM DD, YYYY hh:mm a'
export const DATE_FORMATE = 'MMM DD, YYYY'

export const LOGIN_CONSTANT_TO_CHECK = "accessToken"

export const USER_ROLE = "userRole"

export const CUSTOMER_ID = "customerId"

export const REPORT = {
  CHALLENGE_REPORT_TAB: "5",
  WALLET_REPORT_TAB: "4",
  USER_CHART_TAB: "1",
  ADMIN_ACTIVITY_TAB: "6"
}

export const USERS = {
  SUPER_ADMIN: "superadmin",
  ADMIN: "admin"
}

export const USER_TIME_VALUE_OPTIONS = [
  {
    key: "lifetime",
    label: "All"
  },
  {
    key: "current",
    label: "1 Month"
  },
  {
    key: "quarterly",
    label: "3 Month"
  },
  {
    key: "half-year",
    label: "6 Month"
  },
  {
    key: "year",
    label: "Year"
  }
]

export const EVENT_TYPE_OPTIONS = [
  { label: "Create Tenant App", value: "CREATE_CUSTOMER_APP_EVENT" },
  { label: "Create Tenant Game", value: "CREATE_CUSTOMER_GAME_EVENT" },
  { label: "Update Tenant Game", value: "UPDATE_CUSTOMER_GAME_EVENT" },
  { label: "Delete Tenant Game", value: "DELETE_CUSTOMER_GAME_EVENT" },
  { label: "Update User Status", value: "UPDATE_USER_STATUS_EVENT" },
];